import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { useOpen } from '@/hooks/open';
import { DeleteFilterButton, EditFilterButton, SaveFilterButton } from '../filter-components';
import { ResourceFilterDeleteModal, ResourceFilterEditModal, ResourceFilterSaveModal } from '@/containers/filters/resource-filters/resource-filter-modals';
import { useResourceFilterContext } from './resource-filter-context';
import { isResourceFilterNew, isResourceQueryValid } from './resource-filter-utils';
function ResourceFilterSaveAction(_a) {
    var handlePopoverClose = _a.handlePopoverClose;
    var t = useTranslation().t;
    var _b = useOpen(), open = _b.open, handleClose = _b.handleClose, handleOpen = _b.handleOpen;
    var _c = useResourceFilterContext(), selectedFilter = _c.selectedFilter, setFilter = _c.setFilter, error = _c.error, setError = _c.setError;
    var handleSubmit = useCallback(function (smartgroup) {
        // Only apply filter if returned smartgroup is valid
        if (isResourceQueryValid(smartgroup)) {
            setFilter(smartgroup);
        }
        // Always close modal and popover
        handleClose();
        handlePopoverClose();
    }, [setFilter, handleClose, handlePopoverClose]);
    return (_jsxs(_Fragment, { children: [_jsx(ResourceFilterSaveModal, { open: open, selectedFilter: !!selectedFilter && isResourceFilterNew(selectedFilter) ? selectedFilter : undefined, onClose: handleClose, onSubmit: handleSubmit, translations: {
                    dialogTitle: t('components.resources.filter.save_modal.title'),
                    saveBtn: t('global.buttons.save_and_apply'),
                }, error: error, setError: setError }), _jsx(SaveFilterButton, { label: t('components.resources.filter.button.save'), onClick: handleOpen })] }));
}
function ResourceFilterEditAction(_a) {
    var handlePopoverClose = _a.handlePopoverClose;
    var t = useTranslation().t;
    var _b = useOpen(), open = _b.open, handleClose = _b.handleClose, handleOpen = _b.handleOpen;
    var _c = useOpen(), deleteOpen = _c.open, handleDeleteClose = _c.handleClose, handleDeleteOpen = _c.handleOpen;
    var _d = useResourceFilterContext(), isSelectedFilterApplied = _d.isSelectedFilterApplied, selectedFilter = _d.selectedFilter, dispatchSelectedFilter = _d.dispatchSelectedFilter, setFilter = _d.setFilter, error = _d.error, setError = _d.setError;
    var handleDelete = useCallback(function () {
        // Only clear applied filter and close popover if applied filter is being deleted
        if (isSelectedFilterApplied) {
            setFilter(null);
            handlePopoverClose();
        }
        // Always clear selected filter
        dispatchSelectedFilter({ type: 'clear' });
        // Always close delete confirm and edit modal
        handleDeleteClose();
        handleClose();
    }, [setFilter, dispatchSelectedFilter, handleClose, handleDeleteClose, handlePopoverClose, isSelectedFilterApplied]);
    var handleSubmit = useCallback(function (smartgroup) {
        // Only apply filter if returned smartgroup is valid
        if (isResourceQueryValid(smartgroup)) {
            setFilter(smartgroup);
        }
        // Always close edit modal and popover
        handleClose();
        handlePopoverClose();
    }, [setFilter, handleClose, handlePopoverClose]);
    return (_jsxs(_Fragment, { children: [selectedFilter && _jsx(ResourceFilterDeleteModal, { open: deleteOpen, onClose: handleDeleteClose, onDelete: handleDelete, selectedFilter: selectedFilter }), _jsx(ResourceFilterEditModal, { open: open, selectedFilter: !!selectedFilter && isResourceQueryValid(selectedFilter) ? selectedFilter : undefined, onClose: handleClose, onDelete: handleDeleteOpen, onSubmit: handleSubmit, translations: {
                    dialogTitle: t('components.resources.filter.edit_modal.title'),
                    saveBtn: t('global.buttons.save_and_apply'),
                }, error: error, setError: setError }), _jsx(EditFilterButton, { label: t('components.resources.filter.button.edit'), onClick: handleOpen })] }));
}
function ResourceFilterDeleteAction() {
    var t = useTranslation().t;
    var _a = useOpen(), open = _a.open, handleClose = _a.handleClose, handleOpen = _a.handleOpen;
    var _b = useResourceFilterContext(), selectedFilter = _b.selectedFilter, dispatchSelectedFilter = _b.dispatchSelectedFilter;
    var handleDelete = useCallback(function () {
        // Always clear selected filter
        dispatchSelectedFilter({ type: 'clear' });
        // Always close delete confirm
        handleClose();
    }, [dispatchSelectedFilter, handleClose]);
    return (_jsxs(_Fragment, { children: [selectedFilter && _jsx(ResourceFilterDeleteModal, { open: open, onClose: handleClose, onDelete: handleDelete, selectedFilter: selectedFilter }), _jsx(DeleteFilterButton, { label: t('components.resources.filter.button.delete'), onClick: handleOpen })] }));
}
export function ResourceFilterActions(_a) {
    var handlePopoverClose = _a.handlePopoverClose;
    var selectedFilter = useResourceFilterContext().selectedFilter;
    if (!selectedFilter)
        return null;
    if (isResourceFilterNew(selectedFilter)) {
        return _jsx(ResourceFilterSaveAction, { handlePopoverClose: handlePopoverClose });
    }
    if (isResourceQueryValid(selectedFilter)) {
        return _jsx(ResourceFilterEditAction, { handlePopoverClose: handlePopoverClose });
    }
    return _jsx(ResourceFilterDeleteAction, {});
}
